/**
 * faqs.behavior.js
 *
 * Accordion behaviour for the FAQs component.
 * - Toggles aria-expanded + hidden on trigger / panel pairs.
 * - Supports keyboard navigation (Enter / Space handled natively by <button>).
 * - Only one item open at a time (pass data-faqs-multiple="true" on
 *   .faqs__accordions to allow multiple open items simultaneously).
 *
 * Rename this file to faqs.js in your Drupal theme/module.
 */

(function (Drupal) {
  'use strict';

  /**
   * @param {HTMLElement} item
   * @param {boolean}     open
   */
  function setItemState(item, open) {
    const trigger = item.querySelector('[data-faqs-trigger]');
    const panel   = item.querySelector('[data-faqs-panel]');

    if (!trigger || !panel) return;

    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');

    if (open) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
  }

  /**
   * Close every item inside a given accordion container.
   *
   * @param {HTMLElement} container
   * @param {HTMLElement} [except]  — item to skip (the one being opened)
   */
  function closeAll(container, except) {
    container.querySelectorAll('[data-faqs-item]').forEach(function (item) {
      if (item !== except) {
        setItemState(item, false);
      }
    });
  }

  Drupal.behaviors.faqs = {
    attach: function (context, settings) {
      var items = once('faqs', '[data-faqs-item]', context);

      items.forEach(function (item) {
        var trigger = item.querySelector('[data-faqs-trigger]');

        if (!trigger) return;

        trigger.addEventListener('click', function () {
          var container     = item.closest('.faqs__inner__accordions');
          var isExpanded    = trigger.getAttribute('aria-expanded') === 'true';
          var allowMultiple = container && container.dataset.faqsMultiple === 'true';

          // Close siblings unless multi-open is enabled.
          if (!allowMultiple && container) {
            closeAll(container, item);
          }

          // Toggle clicked item.
          setItemState(item, !isExpanded);
        });
      });
    },

    detach: function (context, trigger, settings) {
      if (trigger !== 'unload') return;

      once.remove('faqs', '[data-faqs-item]', context);
    },
  };

})(Drupal);
